var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',[_vm._v("© "+_vm._s(new Date().getFullYear())+" "+_vm._s(_vm.pageTitle)+". All Rights Reserved. Privacy Policy")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }